module.exports = __webpack_public_path__ + "static/media/strengthTraining.5d88c2a0.jpg";